<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.6665 7.08268C1.6665 4.16602 3.33317 2.91602 5.83317 2.91602H14.1665C16.6665 2.91602 18.3332 4.16602 18.3332 7.08268V12.916C18.3332 15.8327 16.6665 17.0827 14.1665 17.0827H5.83317"
      :stroke="props.color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M14.1668 7.5L11.5585 9.58333C10.7002 10.2667 9.29183 10.2667 8.43349 9.58333L5.8335 7.5"
      :stroke="props.color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M1.6665 13.75H6.6665" :stroke="props.color" stroke-width="1.5" stroke-miterlimit="10"
      stroke-linecap="round" stroke-linejoin="round" />
    <path d="M1.6665 10.416H4.1665" :stroke="props.color" stroke-width="1.5" stroke-miterlimit="10"
      stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  color: {
    type: String,
    default: 'rgb(var(--locumate-primary-color))',
  },
  width: {
    type: Number,
    default: 20,
  },
  height: {
    type: Number,
    default: 20,
  },
});
</script>